import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import SendIcon from '@material-ui/icons/Send';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import FilterListIcon from '@material-ui/icons/FilterList';
import DateFnsUtils from '@date-io/date-fns';
import React, { useEffect, useState } from 'react';
import trLocale from 'date-fns/locale/tr';
import CloseIcon from '@material-ui/icons/Close';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SearchIcon from '@material-ui/icons/Search';
import SearchBar from 'material-ui-search-bar';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';
import { sc, moneyFormat } from 'src/utils/Common';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import {
  Card,
  Avatar,
  Input,
  DialogContent,
  Breadcrumbs,
  Link,
  Typography,
  CardContent,
  Container,
  Divider,
  Dialog,
  DialogTitle,
  DialogActions,
  BottomNavigation,
  BottomNavigationAction,
  Grid,
  IconButton,
  TextField,
  ThemeProvider,
  CardHeader,
  Box,
  FormControlLabel,
  Backdrop,
  CircularProgress,
  Button,
  Snackbar,
  Checkbox,
  Chip,
  TablePagination, ListItemAvatar, ListItem, ListItemText, List, Tabs, Tab,AppBar,OutlinedInput,InputAdornment,DialogContentText
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { createMuiTheme } from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles, withStyles } from '@material-ui/styles';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/ExcelExport';
import UrunSearch from 'src/components/Selects/ProductSearch'
import SerialNumberParse from 'src/components/SerialNumberParse';
import ProductMaterialSearch from 'src/components/Selects/ProductMaterialSearch';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import EditMaterial from 'src/components/SelectMaterial/materialOrderEdit';
import ConsumerAddress from 'src/components/Consumer/ConsumerAddress';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import axiosServiceShop from 'src/utils/customAxios';
import ServiceShopBillTo from 'src/components/ServiceShop/ServiceShopBillTo';
import { useLocation } from 'react-router-dom';
import ServiceShopSearchPartner from 'src/components/ServiceShop/ServiceShopSearchPartner';
import Highlighter from 'react-highlight-words';
import { FaTree } from 'react-icons/fa';
import { AiOutlineCheckSquare } from 'react-icons/ai';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import axiosHeadOffice from 'src/utils/axiosHeadOffice';


//-------------------TABS------------------------
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

//-----------------------------------------

const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  cardscontent: {
    minHeight: 300
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#DEF5E5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
}));



const EXTENSIONS = ['xlsx', 'xls', 'csv']


const TriageMaterialOrder = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [SelectedMaterialPopup, setSelectedMaterialPopup] = useState(false);
  const [UrunData, setUrunData] = useState({});
  const [search] = useState('');
  const [TopBarValue, setTopBarValue] = React.useState(-1);
  const SessionUser = getUser();
  const [stokOpen, setStokOpen] = React.useState(false);
  const [stokData, setStokData] = React.useState([]);
  const [materialAvailabilityCode,setMaterialAvailabilityCode] = React.useState([]);
  const [ErpStatusOpen, setErpStatusOpen] = React.useState(false);
  const [ErpStatusData, setErpStatusData] = React.useState([]);
  const [statusList] = useState([
    { Id: 1, Name: t('lblNew') },
    { Id: 2, Name: t('lblCancel') },
    { Id: 3, Name: t('lblSAPSent') }
  ]);
  
  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [SearchOrderParam, setSearchOrderParam] = React.useState('');
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [QueryPopUp, setQueryPopUp] = useState(false);
  const [ServiceShopData, setServiceShopData] = useState([]);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [preOrderMaterials, setPreOrderMaterials] = React.useState([]);
  const [orderData, setOrderData] = React.useState([]);


  const defaultMaterialOrder = {
    service: SessionUser.ServiceShopName,
    orderNumber: '',
    orderDate: moment().format('YYYY-MM-DD'),
    sapNumber: '',
    jobNumber: '',
    poNumber: '',
    modelCode: '',
    deliveryStatus: '',
    status: statusList[0].Name,
    description: '',
    ServiceShopId:
      SessionUser.UserType === 1 || SessionUser.UserType === 2
        ? SessionUser.ServiceShopId
        : 0
  };



  const [MaterialOrderData, setMaterialOrderData] = useState(
    defaultMaterialOrder
  );
  const [MaterialListData, setMaterialListData] = useState([]); //Product-Material
  const [MaterialListData2, setMaterialListData2] = useState([]); //Only Material

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [QuerySearchScreenData, setQuerySearchScreenData] = useState([]);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [ImagePopup, setImagePopup] = useState(false);
  const [ImageUrl, setImageUrl] = useState('');
  const [currentStatus, setCurrentStatus] = useState(0);
  const [searched, setSearched] = useState('');
  const [openEdit, setOpenEdit] = React.useState(false);
  const [materialId,setMaterialId] = React.useState('');
  const [materialCode,setMaterialCode] = React.useState('');
  const [materialDesc,setMaterialDesc] = React.useState('');
  const [sparePartMessage, setSparePartMessage] = React.useState('');
  const [sparePartMap, setSparePartMapData] = React.useState([]);
  const [SelectedProductMaterialPopup, setSelectedProductMaterialPopup] = useState(false);
  const [MissingMaterialsPopUp, missingMaterialsPopUp] = React.useState(false);
  const [MissingMaterials, missingMaterials] = React.useState([]);
  const [initialRows, setinitialRows] = useState('');
  const [inputText, setInputText] = useState("");
  const [openWarning, setopenWarning] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [serviceShopDetails, setServiceShopDetails] = useState([]);
  const [serviceDsc, setServiceDsc] = useState([]);
  const [loading2, setLoading2] = useState(false);

  const [muadilOpen, setMuadilOpen] = React.useState(false);
  const [muadilParam, setMuadilParam] = React.useState('');
  const [muadilTitle, setMuadilTitle] = React.useState('');
  const [equivalentData, setEquivalentData] = React.useState([]);

  const [stokDataOwnEngineer, setStokDataOwnEngineer] = React.useState([]);
  const [stockMsg,setStockMsg] = React.useState('');
  const [serviceShopTypeId,setServiceShopTypeId] = React.useState();
  const [IsAllOwnEngineer,setIsAllOwnEngineer] = React.useState(false);
  const [backButtonVisible, setBackButtonVisible] = React.useState(false);
  const [rowData,setRowData] = React.useState(false);

  const [bomData,setBomData] = useState([]);

  useEffect(() => {
    if (props?.MaterialOrderIdPopup > 0) {
      setSearchOrderParam(props?.MaterialOrderIdPopup);
      GetMaterialOrderParamNew(props?.MaterialOrderIdPopup);
    }
  }, [props?.MaterialOrderIdPopup]);



  const [QuantityState, setQuantityState] = useState({
    value:1,
    show:1,
    backgroundColor:'white',
  });

  //---------------------YENI-----------------------
  const [ServiceShopSearchPopUp, setServiceShopSearchPopUp] = useState(false);

  const defaultServiceAddressData = { 
  AddressType: '',
  Address: '',
  State: '',
  AddressItem: '',
  Apartment: '',
  City: '',
  Country: SessionUser.TenantCode.toUpperCase(),
  District: '',
  DoorNr: '',
  Neighborhood: '',
  PostCode: '',
  Region: '',
  Street: '',
  Phone: '',
  Email: '',
  Name:'',
  ShipTo:'',
  Dsc:'',
  TaxNumber:'',
  ServiceShopId: '',
  ConsumerAddressTypeId: 1,
  AddressId: 0 }

  const [serviceAddressData,setServiceAddressData] = useState(defaultServiceAddressData);
  //------------------------------------------------


  const [tabsValue, setTabsValue] = React.useState(0);
  const handleChangetabs = (event, newValue) => {
    setTabsValue(newValue);
  };

  const handleClickService = (obj,row) => {
    setServiceAddressData(row);
    setServiceShopSearchPopUp(false);
  };

  const GetServiceShopShiptoPoints = () => {
    setLoading(true);
    setServiceShopDetails([]);
      axios
      .get(`/GetServiceShopShiptoPoints/` + SessionUser.ServiceShopId)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setServiceAddressData(response.data[0]);
        }else{
          setServiceAddressData([]);
          const informationAlert = t('lblNoFoundServiceShop');
          setUyari(informationAlert);
          setopenWarning(true);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }


  //-----------------CONSUMER ADDRESS------------------
  function setStreetData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            Street: newValue
        }));
  }
  function setApartmentData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            Apartment: newValue
        }));
  }
  function setAddressData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            Address: newValue
        }));
  }
  function setStateData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            State: newValue
        }));
  }
  function setAddressItemData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            AddressItem: newValue
        }));
  }
  function setCityData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            City: newValue
        }));
  }
  function setCountryData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            Country: newValue
        }));
  }
  function setDistrictData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            District: newValue
        }));
  }
  function setDoorNrData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            DoorNr: newValue
        }));
  }
  function setNeighborhoodData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            Neighborhood: newValue
        }));
  }
  function setTaxNumberData(newValue){
    setServiceAddressData(prevAddressData => ({
        ...prevAddressData,
        TaxNumber: newValue
    }));
}
  function setPostCodeData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            PostCode: newValue
        }));
  }
  function setRegionData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            Region: newValue
        }));
  }
  function setEmailData(newValue){
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Email: newValue
    }));
  }
  function setPhoneData(newValue){
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Phone: newValue
    }));
  }
  function setNameData(newValue){
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Name: newValue
    }));
  }
  function setAddressTypeIdData(newValue){
        setServiceAddressData(prevAddressData => ({
            ...prevAddressData,
            AddressTypeId: newValue
        }));
  }
  //-----------------------------------------


  const updateWorkOrder = statusId => {
    saveWorkOrder(statusId);
  };

  const ValidateFields = () => {
    const consumerIsNull = !!(
      serviceAddressData.ServiceShopId === '' ||
      serviceAddressData.ServiceShopId === undefined
    );

    const workOrderIdIsNull =
    (SessionUser.TenantId !== 82 || SessionUser.TenantId !== 61 || SessionUser.TenantId !== 48 )
      ? false 
      : !!(
          MaterialOrderData.jobNumber === '' ||
          MaterialOrderData.jobNumber === undefined
        );
        
    const sparePartListIsEmpty = preOrderMaterials.length === 0;

    if (
      consumerIsNull ||
      workOrderIdIsNull ||
      sparePartListIsEmpty
    ) {
      return false;
    }

    return true;
  };

  async function saveWorkOrder(StatusId) {

    const response = await axios.get(`/GetWorkOrderStatus/${MaterialOrderData.jobNumber || 0}`);
    const fetchedWorkOrderStatus = response.data.length > 0 && response.data !== "" ? response.data : [];

    //If we have not entered a workorderId or if there is no such workOrderId in the system, we do not check.
    const isWorkOrderOpen = fetchedWorkOrderStatus.length > 0 ? fetchedWorkOrderStatus[0].IsOpen : true;

    var foc = QuerySearchScreenData  != null ? QuerySearchScreenData[0]?.FreeOfCharge 
    : orderData ? orderData.FreeOfCharge : 0; 

    if (!foc && !isWorkOrderOpen) {
      // If the work order is closed, we do not save the order and issue a warning
      setResponseType('error');
      setResponseDsc(t('lblIsOpenWorkOrder'));
      setOpenSnackbar(true);
      return; 
    } 

    if (ValidateFields()) {
      setLoading(true);
      const SetMaterialOrderDetailRequestDto = [];
      for (let i = 0; i < preOrderMaterials.length; i++) {
        const tmpSparePartData = {
          MaterialOrderId: 0,
          ItemNr: preOrderMaterials.map(x => x.MaterialId).indexOf(preOrderMaterials[i].MaterialId),
          MaterialId: preOrderMaterials[i].MaterialId,
          MaterialIdReplaced:0,
          Qty: preOrderMaterials[i].Quantity,
          ProductId: preOrderMaterials[i].ProductId,
          ShipedQty:0,
          MaterialOrderDetailStatusId: StatusId,
          ItemNote: ''
        };
        SetMaterialOrderDetailRequestDto.push(tmpSparePartData);
      }

      const SetMaterialOrderAddressRequestDto = [];
        const tmpSparePartData = {
          MaterialOrderId:0,
          AddressType: serviceAddressData.ConsumerAddressTypeId,
          State: serviceAddressData.State,
          Address: serviceAddressData.Address,   //GetConsumerForMaterialOrder da AddressItem olarak GetServiceShopById ' de Address olarak geliyor 
          Apartment: serviceAddressData.Apartment,
          City: serviceAddressData.City,
          Country: serviceAddressData.Country,
          District: serviceAddressData.District,
          DoorNr: serviceAddressData.DoorNr,
          Neighborhood: serviceAddressData.Neighborhood,
          PostCode: serviceAddressData.PostCode,
          Region: serviceAddressData.Region,
          Street: serviceAddressData.Street,
          Email: serviceAddressData.Email,
          Phone: serviceAddressData.Phone,
          Name: serviceAddressData.Name,
          ServiceShopId: serviceAddressData.ServiceShopId
        };
        SetMaterialOrderAddressRequestDto.push(tmpSparePartData);

      const setMaterialRequestDto = {
        Id: MaterialOrderData.orderNumber == '' ? 0 : MaterialOrderData.orderNumber,
        MaterialOrderStatusId:StatusId,
        BillToOtc: 0,
        BillToConsumerId: 0,
        BillToServiceShopId: SessionUser.ServiceShopId,
        BillToRetailerId: 0,
        ShipToToOtc: 0,
        ShipToToConsumerId: 0,
        ShipToToServiceShopId: serviceAddressData.IsRetailer == 0 ? serviceAddressData.ServiceShopId : 0,
        ShipToToRetailerId: serviceAddressData.IsRetailer == 1 ? serviceAddressData.RetailerId : 0,
        OtcPhone:'',
        OtcTaxOffice:'',
        OtcTaxNr:serviceAddressData.TaxNumber,
        WorkOrderId: props.WorkOrderId,
        Dsc : MaterialOrderData.description,
        FreeOfCharge: orderData ? orderData.FreeOfCharge ? 1 : 0 : 0,
        CreateDate: moment().format('YYYY-MM-DD'),
        LastUpdateEmployeeId: SessionUser.TechnicianId,
        PONumber: MaterialOrderData.poNumber,
        SapNr: MaterialOrderData.ErpDocumentNr,
        SapShipToCode: serviceAddressData.SapShiptoCode,
        MaterialOrderAddress: SetMaterialOrderAddressRequestDto,
        MaterialOrderDetails: SetMaterialOrderDetailRequestDto
      };

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      axios
        .post('/SetMaterialOrder', setMaterialRequestDto, config)
        .then(response => {
          if (response.data.IsSuccess) {
            const tmpStatus = statusList.find(x => x.Id === StatusId).Name;
            const tmpStatusId = statusList.find(x => x.Id === StatusId).Id;
            setMaterialOrderData({
              ...MaterialOrderData,
              orderNumber: response.data.OrderNr,
              status: tmpStatus,
              sapNumber: response.data?.SapNr || ''
            });

            if(SessionUser.TenantId === 16 && tmpStatusId === 3){
              GetMaterialOrderParam(response.data.OrderNr);
            }

            setCurrentStatus(StatusId);
            setResponseType('success');
            setResponseDsc(t('success_message'));
            setOpenSnackbar(true);
            props.getOrderNr(response.data.OrderNr);
          }else if(response.data.ErrorMessage === 'IsSapCountryError'){
            setResponseType('error');
            setResponseDsc(t('lblIsSapCountryError'));
            setOpenSnackbar(true);
          } else {
            setResponseType('error');
            setResponseDsc(response.data.ErrorMessage);
            setOpenSnackbar(true);
          }
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    } else {
      handleSnackbarClick();
    }
  }

  const handleSnackbarClick = () => {
    setResponseType('error');
    if(SessionUser.TenantId == 82 || SessionUser.TenantId == 61 || SessionUser.TenantId == 48 ){
      setResponseDsc(t('lblMissingFieldsHK'));
    }else{
      setResponseDsc(t('lblMissingFields'));
    }
    setOpenSnackbar(true);
  };

  const clearPage = () => {
    setMaterialOrderData(defaultMaterialOrder);
    setMaterialListData([]);
    setServiceAddressData(defaultServiceAddressData);
    setPreOrderMaterials([]);
  };

  const GetMaterialOrderParam = (orderId) => {
    clearPage();
    setCurrentStatus(0);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: 0,
      StartDate,
      EndDate,
      ServiceShopId: serviceAddressData.ServiceShopId != "" ? serviceAddressData.ServiceShopId : SessionUser.ServiceShopId,
      OrderNr: SearchOrderParam ? SearchOrderParam : orderId
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > 0) {
          setQuerySearchScreenData(Response);
          const tempData = Response[0];
          setQuery(tempData);
        } else {
          setQuerySearchScreenData([]);
          setResponseType('warning');
          setResponseDsc(t('lblOrderSearchMessage'));
          setOpenSnackbar(true)
        }
        setLoading(false);

      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const location = useLocation();
  const selectedRow = location.state ? location.state : '';
  
  useEffect(() => {
    setQuery(selectedRow);
  }, [selectedRow]);

  const setQuery = row => {
    if(row == ""){
      return;
    }else{
      const defaultMaterialOrderParam = {
        ServiceShopId: row.ServiceShopId,
        service: `${row.SourceServiceShopCode} ${row.ServiceShop}`,
        orderNumber: row.MaterialOrderId,
        orderDate: row.OrderDate,
        sapNumber: row.SapNr ? row.SapNr : '',
        jobNumber: row.WorkOrderId ? row.WorkOrderId : '',
        modelCode: '',
        deliveryStatus: row.DeliveryStatus,
        status: row.MaterialOrderStatus,
        description: row.Dsc,
        poNumber: row.poNumber
      };

  
      const DetailData = [];
      if(row.MaterialOrderDetails && Array.isArray(row.MaterialOrderDetails))
        row.MaterialOrderDetails.forEach(item => {
        const Data = {};
        Data.MaterialId = item.MaterialId;
        Data.MaterialCode = item.MaterialCode;
        Data.MaterialDesc = item.Material;
        Data.ItemNr = item.ItemNr;
        Data.Quantity = item.Qty;
        Data.UseQuantity = item.OriginalQty;
        Data.Price = SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? item.Price : 0;
        Data.PriceWithWat = SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? item.PriceWithWat : 0;
        Data.Total = SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? item.PriceWithWat * item.Qty : 0;
        Data.ProductId = item.ProductId
        Data.ProductName = item.ProductName
        Data.ItemNote = item.ItemNote
        DetailData.push(Data);
  
  
            setServiceAddressData({
              ConsumerAddressTypeId:row.AddressTypeId,
              Address: row.Address,
              State: row.State,
              Apartment: row.Apartment,
              City: row.City,
              Country: row.Country,
              District:row.District,
              DoorNr: row.DoorNr,
              Neighborhood: row.Neighborhood,
              PostCode:row.PostCode,
              Region: row.Region,
              Street: row.Street,
              Email: row.Email,
              Phone: row.Phone,
              Name: row.ConsumerFullName,
              ServiceShopId: row.ServiceShopId,
              ShipTo: row.ShipTo
            });
  
  
            setAddressItemData(row.ConsumerAddress);
            setStateData(row.ConsumerState);
            setApartmentData(row.ConsumerApartment);
            setCityData(row.ConsumerCity);
            setCountryData(row.ConsumerCountry);
            setDistrictData(row.ConsumerDistrict);
            setDoorNrData(row.ConsumerDoorNr);
            setNeighborhoodData(row.ConsumerNeighborhood);
            setTaxNumberData(row.TaxNumber);
            setPostCodeData(row.ConsumerPostCode);
            setRegionData(row.ConsumerRegion);
            setStreetData(row.ConsumerStreet);
            setEmailData(row.Email);
            setPhoneData(row.Phone);
            setNameData(row.ConsumerFullName);
            setAddressTypeIdData(row.ConsumerAddressType);
      });
  
      setCurrentStatus(row.StatusId);
      setMaterialOrderData(defaultMaterialOrderParam);
      setPreOrderMaterials(DetailData);
      setOrderData(row);
      setQueryPopUp(false);
      // setQuerySearchScreenData([]);
    }
   
  };

  const localeMap = {
    tr: trLocale
  };

  const locale = localStorage.getItem('i18nextLng');

  const siyah = '#424242';
  const materialTheme = createMuiTheme({
    palette: {
      primary: {
        contrastText: '#FFFFFF',
        dark: siyah,
        main: siyah,
        light: siyah
      }
    }
  });

  function GetHistoricalBom(SKU,ProductYear,ProductMonth) {
    var ServiceShopId = SessionUser.ServiceShopId;
    setMaterialListData([]);
    setLoading(true);
      axios
        .get(`/GetHistoricalBom/${SKU}/${ProductMonth || 0}/${ProductYear || 0}/${ServiceShopId}`)
        .then(response => {
          var data = response.data;
          if(data.length > 0){
            setLoading(false);
            setBomData(data);
            setMaterialListData(response.data);
          }
        })
        .catch(error => {
          setLoading(false);
          setMaterialListData([]);
          setResponseType('error');
          setResponseDsc(t('lblError'));
          setOpenSnackbar(true)
        });
  }


  const SetDate = value => {
    const DateValue = moment(value).format('YYYY-MM-DD');
    setMaterialOrderData({ ...MaterialOrderData, orderDate: DateValue });
  };

  const ErpStatusPopup = (ErpNr) => {
    axios
      .get('/GetErpWarehouseMaterialStatus/' + ErpNr + '/' + localStorage.getItem('i18nextLng'))
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setErpStatusData(res);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    setErpStatusOpen(true);
  }

  const exportMaterialData = (data) => {
    var json = []
    for (let i = 0; i < data?.length; i++) {
      var temp = {};
      temp.ProductId = data[i].ProductId;
      temp.MaterialCode = data[i].MaterialCode;
      temp.MaterialDesc = data[i].MaterialDesc;
      temp.Ref = data[i].Ref;
      temp.lblQuantity = data[i].Quantity;
      temp.UseQuantity = data[i].UseQuantity;
      temp.Price = SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? data[i].Price : 0;
      temp.PriceWithWat = SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? data[i].PriceWithWat : 0;
      temp.lblTotal = SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? data[i].Total : 0;
      json.push(temp)
    };

    return json
  };

  const exportExcelExample = [{
    'MaterialCode':'',
    'Quantity':''
}];

  const handleQuantityChange = (e,row) => {
    const tmpRow = row;
    const tmpList = [...preOrderMaterials];
    const ifAlreadyHaveItem = tmpList.find(
        x => x.MaterialId === tmpRow.MaterialId
      );

    if (ifAlreadyHaveItem === undefined || ifAlreadyHaveItem === null) {
        tmpRow.Quantity = 1;
        tmpRow.Total = tmpRow.Quantity * tmpRow.PriceWithWat;
        tmpList.push(tmpRow);
    } else {
        var quantity = e.target.value;
        
        // Quantity rules
        if(quantity > 999)
        {
          quantity = 999
        }
        else if(quantity < 0)
        {
          quantity = 0
        }

        const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
        tmpList[index].Quantity = quantity;
        tmpList[index].Total = 
          tmpList[index].Quantity * tmpList[index].PriceWithWat;
        }
    
    setPreOrderMaterials(tmpList);
    setQuantityState({value: quantity, backgroundColor: quantity > 0 ? 'white':'red'})
  };

  const deleteFromMaterialTable = row => {
    const tmpListData = [...preOrderMaterials];
    const index = tmpListData.findIndex(x => x.MaterialId === row.MaterialId);
    tmpListData.splice(index, 1);
    setPreOrderMaterials(tmpListData);
  };

  const StokControlPopup = (row) => {
    const Request = {
        MaterialCode: [row.MaterialCode],
        ServiceShopCode: SessionUser.ServiceShopCode
      };
  
      const RequestHeaders = {
        headers: { 'Content-Type': 'application/json' }
      };
      axios
        .post('/GetMaterialAvailabilitySirius', Request, RequestHeaders)
        .then(response => {
            const res = response.data.length === 0 ? [] : response.data;
            const stokQuantity = res.map(item => ({
                ...item,
                Quantity: parseInt(item.Quantity, 10)
            }));
            setStokData(stokQuantity);
            setMaterialAvailabilityCode(row.MaterialCode);
            setLoading(false);
        })
        .catch(error => {
            setLoading(false);
        });
    setStokOpen(true);
    GetMaterialAvailabilityOwnEngineer(row,false);
    setRowData(row);
  }

  function setQuantityNum(value,id){
    const tmpListData = [...preOrderMaterials];
    const index = tmpListData.findIndex(x => x.MaterialId === id);
    tmpListData[index].Quantity = value;
    tmpListData[index].Total = tmpListData[index].Quantity * tmpListData[index].PriceWithWat;
    setPreOrderMaterials(tmpListData);
  }

  function setProductMaterial(materialData) {
    if (UrunData.Model && UrunData.ModelCode) {
      if (UrunData.ProductId >= 1000000) {
        setMaterialListData([]);
        materialData.ProductId = UrunData.ProductId
        materialData.ProductName = UrunData.Model
        let result = []
        result.push(materialData)
        setMaterialListData(result);
        setinitialRows(result);
      }
    }
    else {
      setResponseType('error');
      setResponseDsc(t('lblChooseProduct'));
      setOpenSnackbar(true)
    }

  }

  const requestSearch = (searchedVal) => { //Product-Material -Material Search
    const filteredRows = initialRows.filter((item) => sc(
      item.MaterialCode + item.MaterialDesc + item.Ref + item.PriceWithWat.toFixed(2),
      searchedVal
    ));
    setMaterialListData(filteredRows);
    setPage(0);
  };

  const requestSearch2 = (searchedVal) => { //Only Material -Material Search
    const filteredRows = initialRows.filter((item) => sc(
      item.MaterialCode + item.MaterialDesc + item.PriceWithWat.toFixed(2),
      searchedVal
    ));
    setMaterialListData2(filteredRows);
    setPage(0);
  };

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  const malzemeGosterMaterial = materialCode => {
    const data = {
      MaterialCode: materialCode
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/FileImportExport/SiriusMaterialImage', data, config)
      .then(response => {
        const fileURL = URL.createObjectURL(response.data);

        // newWindow.location = fileURL;
        // newWindow.document.title = materialCode;
        setImageUrl(fileURL);
        setImagePopup(true);
      })
      .catch(error => { });
  };

  function addToMaterialTable(row,IsTriage) {
        const tmpRow = row;
        const tmpList = [...preOrderMaterials];
        const ifAlreadyHaveItem = tmpList.find(
          x => x.MaterialId === tmpRow.MaterialId
        );
        if (ifAlreadyHaveItem === undefined || ifAlreadyHaveItem === null) {
          tmpRow.Quantity = 1;
          tmpRow.Total = tmpRow.Quantity * tmpRow.PriceWithWat;
          tmpList.push(tmpRow);
        }else if(IsTriage === 1){
          const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
          tmpList[index].Quantity = 1;
          tmpList[index].Total = 
            tmpList[index].Quantity * tmpList[index].PriceWithWat;
        }
         else {
          const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
          tmpList[index].Quantity += 1;
          tmpList[index].Total = 
            tmpList[index].Quantity * tmpList[index].PriceWithWat;
        }
    
        setPreOrderMaterials(tmpList);
        setMaterialId(row.MaterialId);
        setMaterialCode(row.MaterialCode);
        setMaterialDesc(row.MaterialDesc);
        // setOpenEdit(true);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const GetSiriusMaterialsBySearchKey = (equivalent,materialCode) =>{
    const Request = {
      SearchParam: equivalent.toLocaleLowerCase(localStorage.i18nextLng_normalized),
      ServiceShopId: SessionUser.ServiceShopId
    };
  setLoading(true);

  const RequestHeaders = {
    headers: { 'Content-Type': 'application/json' }
  };
  axios
    .post('/GetSiriusMaterialsBySearchKey', Request, RequestHeaders)
    .then(response => {
      setLoading(false);
      if (response.data.length > 0) {
        setEquivalentData(response.data);
        MuadilMalzemeGoster(equivalent, materialCode); 
      }else{
        setEquivalentData([]);
        const informationAlert = t('lblMissingMaterial');
        setUyari(informationAlert);
        setopenWarning(true);
      }
  })
  .catch(error => {
    setLoading(false);
  });
}

  const setSearchMaterial = param => {
    setMaterialListData2([]);

    setLoading(true);
    const Request = {
      SearchParam: inputText.toLocaleLowerCase(localStorage.i18nextLng_normalized),
      ServiceShopId: SessionUser.ServiceShopId
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetSiriusMaterialsBySearchKey', Request, RequestHeaders)
    .then(response => {
      setLoading(false);
      if (response.data.length > 0) {
        setMaterialListData2(response.data);
        setinitialRows(response.data);
      }else{
        setMaterialListData2([]);
        const informationAlert = t('lblMissingMaterial');
        setUyari(informationAlert);
        setopenWarning(true);
      }
    })
    .catch(error => {
      setLoading(false);
    });
  }

  const setModel = (param) => {
    setMaterialListData([]);

    const job = {
       ModelCode: param.KUL_MODEL_KODU,
       Model: param.ACIKLAMA,
       HomeWhiz: param.HOMEWHIZ,
       BrandCode: param.MARKA_KODU,
       ProductId: param.MODEL_KODU
    };

     setUrunData(job);

    const Request = {
        SearchParam: param.KUL_MODEL_KODU,
        ServiceShopId: SessionUser.ServiceShopId
      };
    setLoading(true);

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetSiriusMaterialsBySearchKey', Request, RequestHeaders)
      .then(response => {
      setLoading(false);
      if (response.data.length > 0) {
        setMaterialListData(response.data);
        setinitialRows(response.data);
      }else{
        setMaterialListData([]);
        const informationAlert = t('lblMissingMaterial');
        setUyari(informationAlert);
        setopenWarning(true);
      }
    })
    .catch(error => {
      setLoading(false);
    });
  }

  const handleChange = event =>{
    setInputText(event.target.value);
  }

  // Import excel function
  function setSearcByExcelhMaterial (excelData) {
    setMaterialListData2([]);

    setLoading(true);
    
    const request = {
      ExcelDataFormat : excelData,
      ServiceShopId: JSON.stringify(SessionUser.ServiceShopId)
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    // A comparer used to determine if two entries are equal.
    const isSameMaterial = (a, b) => a.MaterialCode === b.MaterialCode;

    const onlyInLeft = (left, right, compareFunction) => 
  left.filter(leftValue =>
    !right.some(rightValue => 
      compareFunction(leftValue, rightValue)));

    axiosServiceShop // service shop url
    .post('/GetSiriusMaterialByExcelData', request,config)
    .then(response => {
      setLoading(false);
      if (response.data.length > 0) {
        response.data.forEach(element => {
          element.Total = element.Quantity * element.PriceWithWat;
        });

        var missingValues = onlyInLeft(excelData,response.data,isSameMaterial);

        setMaterialListData2(response.data); // Material Choose popup
        setPreOrderMaterials(response.data); // Table
        setinitialRows(response.data);
        
        if(missingValues.length > 0)
        {
          missingMaterials(missingValues);
          missingMaterialsPopUp(true);
        }

        setSelectedMaterialPopup(false); // Close popup
      }else{
        setMaterialListData([]);
      }
    })
    .catch(error => {
      setLoading(false);
    });
  }

  const getExention = (file) => {
    const parts = file.name.split('.')
    const extension = parts[parts.length - 1]
    return EXTENSIONS.includes(extension) // return boolean
  }

  const importExcel = (e) => {
    const file = e.target.files[0]
    const reader = new FileReader()
    if (file) {
      setLoading(true)
      if (getExention(file)) {
        reader.readAsBinaryString(file)
      }
      reader.onload = (event) => {
        //parse data
        const bstr = event.target.result
        const workBook = XLSX.read(bstr, { type: "binary" })
        //get first sheet
        const workSheetName = workBook.SheetNames[0]
        const workSheet = workBook.Sheets[workSheetName]
        //convert to array
        const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 })
        // Create excel data array
        var excelData = [];

        for (var i = 1; i < fileData.length; i++) {
          // Check related row data is empty or quantity is valid
          if((fileData[i][0] !== undefined && fileData[i][0] !== null && String(fileData[i][0]).trim() !=='') && ( fileData[i][1] !== undefined && fileData[i][1] !== null && String(fileData[i][1]).trim() !=='' && !isNaN(+String(fileData[i][1])) && parseInt(String(fileData[i][1])) > 0 ))
          {
            var quantity = parseInt(String(fileData[i][1])) > 999 ? '999' : String(fileData[i][1])
             // Add array to related row
            excelData.push({MaterialCode :String(fileData[i][0]),Quantity : quantity})
          }
        }
        
        if(excelData.length > 0)
        {
          // Get related material
          setSearcByExcelhMaterial(excelData);
        }
      }
    }
  }

  const handleCloseEdit = value => {
    setOpenEdit(false);
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: 'rgb(60, 179, 113)',
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const getSpareUserColor = s => {
    if (s.Quantity !== "0,0") {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <AccountCircleIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"

          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <AccountCircleIcon />
        </Avatar>
      );
    }
  };

  const getStokColor = s => {
    if (s.Quantity > 0) {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"

          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    }
  };

  const handleBackButtonClick = () => {
    setBackButtonVisible(false); 
    GetMaterialAvailabilityOwnEngineer(rowData,false); 
  };

  const GetMaterialAvailabilityOwnEngineer = (row,value) => {
    setIsAllOwnEngineer(value);
  
    setLoading2(true);
  
    const Request = {
      MaterialCode: [row.MaterialCode],
      ServiceShopId: SessionUser.ServiceShopId,
      IsAllOwnEngineer : value
    };
  
    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialAvailabilityOwnEngineer', Request, RequestHeaders)
      .then(response => {
        const res = response.data.length === 0 ? []  : response.data ;
        if(res.length > 0){
          const stokQuantity = res.map(item => ({
          ...item,
          Quantity: parseInt(item.Quantity, 10)
          }));
          setStokDataOwnEngineer(stokQuantity);
          setServiceShopTypeId(res[0].ServiceShopTypeId);
        }
        else{
          setStokDataOwnEngineer([]);
          setStockMsg(t('lblStockMsg'))
        }
        
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
    }
  
    const StockSearch = () => {
      GetMaterialAvailabilityOwnEngineer(rowData,true);
      setBackButtonVisible(true);
    }


  const GetMaterialOrderParamNew = (OrderId) => {
    clearPage();
    setCurrentStatus(0);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: 0,
      StartDate,
      EndDate,
      ServiceShopId: SessionUser.ServiceShopId,
      OrderNr: OrderId
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
          setQuery(Response[0]);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);

      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const GetServiceShopByTenant = () => {
    setLoading(true);

      axios
      .get(`/GetServiceShopByTenant`)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setServiceShopData(response.data);
        }else{
          setServiceShopData([]);
          const informationAlert = t('lblNoFoundServiceShop');
          setUyari(informationAlert);
          setopenWarning(true);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const GetServiceShopDetails = (ServiceShopId) => {
    setLoading(true);
      axios
      .get(`/GetServiceShopDetails/` + ServiceShopId)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setServiceShopDetails(response.data);
          setServiceDsc(response.data[0].SourceServiceShopCode + '-' + response.data[0].Dsc);
        }else{
          setServiceShopDetails([]);
          const informationAlert = t('lblNoFoundServiceShop');
          setUyari(informationAlert);
          setopenWarning(true);
        }
      })
      .catch(error => {
        setLoading(false);
      });
    }

    const fetchMaterials = async () => {
        try {
            if(props.MaterialIds !== undefined || props.MaterialIds !== null){
                var response = await axiosHeadOffice.get(`/GetMaterialsByIds/${props.MaterialIds}/${SessionUser.ServiceShopId}`);
                setPreOrderMaterials(response.data);
            }
        } catch (error) {
            console.error('Error fetching materials:', error);
        }
      };
    
    useEffect(() => {
        if (props.MaterialIds) {
            fetchMaterials(props.MaterialIds);
        }
    }, [locale]);

    useEffect(() => {
      GetServiceShopByTenant();
      GetServiceShopDetails(SessionUser.ServiceShopId);
      GetServiceShopShiptoPoints();
  }, [locale]);

  const blockInvalidChar = e => ['e', 'E', '+', '-','.'].includes(e.key) && e.preventDefault();

  const highlight = text => {
    return (
      <Highlighter
        searchWords={[]}
        autoEscape
        textToHighlight={text}
      />
    );
  };

  const MuadilMalzemeGoster = (txt, malzeme) => {
    setMuadilParam(txt);
    setMuadilTitle(malzeme);
    setMuadilOpen(true);
  };


  const getMaterialRow = (row, index) => {
    if (row === undefined) {
      return '';
    }

    const rowI = row[0];
    const labelId = `enhanced-table-checkbox-${index}`;
    const isItemSelected = preOrderMaterials.some(x => x.MaterialCode == rowI.MaterialCode);
    const disabled = !isItemSelected;
    return (
      <TableRow
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        selected={isItemSelected}
        key={index}
      >
        <TableCell className={classes.tableCell}>
          {
            rowI.HistoricalBom === 0
              ? <AiOutlineCheckSquare style={{ color: 'green' }} size="20" />
              : <FaTree style={{ color: 'orange' }} size="20" />
          }
        </TableCell>
        <TableCell className={classes.tableCell}>
          <TrackChangesIcon
            onClick={() => { MuadilMalzemeGoster(rowI.ActiveEquivalent, rowI.MaterialCode)}}
            color="primary"
          >
          </TrackChangesIcon>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <ImageSearchIcon
            onClick={() => malzemeGosterMaterial(rowI.MaterialCode)}
            color="primary"
          >
          </ImageSearchIcon>
        </TableCell>
        <TableCell
          scope="row"
          onClick={() =>
            addToMaterialTable(rowI,0)}
        >
          <Grid container spacing={0}>
            <Grid
              style={{ color: rowI.CanBeOrdered ? 'inherit' : 'red' }}
              item
              xs={12}
            >
              <b>{highlight(rowI.MaterialCode)}</b>
              {' '}
              {highlight(rowI.MaterialDesc)}
              <b>
                {rowI.ActiveEquivalent.length > 0 && (
                  <Chip color="secondary" size="small" label="M" />
                )}
              </b>
            </Grid>
          </Grid>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <b>
            <Chip
              size="small"
              label={`${moneyFormat(
                rowI.Price,
                SessionUser.TenantCode,
                SessionUser.CurrencyUnit
              )} ${SessionUser.CurrencyUnit}`}
            />
          </b>
        </TableCell>
        <TableCell className={classes.tableCell} align="right">
          <b>{'%' + (rowI.VatRate * 100).toFixed(2)}</b>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <b>
            <Chip
              size="small"
              label={`${moneyFormat(
                rowI.PriceWithWat,
                SessionUser.TenantCode,
                SessionUser.CurrencyUnit
              )} ${SessionUser.CurrencyUnit}`}
            />
          </b>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <b>Ref:{highlight(rowI.Ref)}</b>
        </TableCell>
        <TableCell
          padding="checkbox"
          onClick={() =>
            addToMaterialTable(rowI,0)}
        >
          <Checkbox
            checked={isItemSelected}
            inputProps={{ 'aria-labelledby': labelId }}
            color="primary"
            disabled={disabled}
          />
        </TableCell>
      </TableRow>
    );
  };

  const defaultDescription = `Preordered for ${props.WorkOrderId} work order.`;

    return(
      <Page>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
        >
          <Alert
            onClose={handleSnackbarClose}
            message={ResponseDsc}
            variant={ResponseType}
          />
        </Snackbar>
        <Container maxWidth="xl">
                  <Breadcrumbs>
                    <Link color="inherit">Sirius</Link>
                    <Typography color="textPrimary">{t('Material_Order')}</Typography>
                    <Typography color="textPrimary">{t('Create')}</Typography>
                    <Typography color="textPrimary">{t('ForPartner')}</Typography>
                  </Breadcrumbs>
                  <Card>
                    <BottomNavigation
                      value={TopBarValue}
                      className={classes.stickToBottom}
                      onChange={(event, newValue) => {
                        setTopBarValue(newValue);
                        if (newValue === 0) {
                          saveWorkOrder(1);
                          // KAYDET
                        }
                        if (newValue === 1) {
                          // NEW ORDER
                          clearPage();
                          setCurrentStatus(0);
                        }
                        if (newValue === 2) {
                          // İPTAL
                          updateWorkOrder(newValue);
                        }
                        if (newValue === 3) {
                          // SAP GÖNDER
                          updateWorkOrder(newValue);
                        }
                      }}
                      showLabels
                    >
                      {currentStatus === 3 || currentStatus === 4 ? (
                        ''
                      ) : (
                        <BottomNavigationAction
                          label={t('lblSave')}
                          icon={<SaveIcon />}
                        />
                      )}
                      <BottomNavigationAction
                        label={t('lblNewOrder')}
                        icon={<AddShoppingCartIcon />}
                      />
                      {
                        (currentStatus === 1) ? (
                        <BottomNavigationAction
                          label={t('lblCancel')}
                          icon={<CancelIcon />}
                        />
                      ) : (
                        ''
                      )}
                      {
                        currentStatus === 1 || currentStatus === 4 ? (
                        <BottomNavigationAction
                          label={t('lblSendToSap')}
                          icon={<SendIcon />}
                        />
                      ) : (
                        ''
                      )}
                    </BottomNavigation>
                  </Card>
                  <Divider />
            <Card>
              <CardHeader title={t('lblMaterialOrderInformation')}
                action={
                  <Paper className={classes.searchB} elevation={1}>
                    <Input
                      className={classes.searchInputB}
                      disableUnderline
                      onChange={(event) => {
                        setSearchOrderParam(event.target.value);
                      }}
                      placeholder={t('lblOrderNumber')}
                    />
                    <SearchIcon
                      onClick={() => GetMaterialOrderParam()}
                      className={classes.searchIconB}
                    />
                  </Paper>
                }
              />
              <Divider />
              <CardContent>
                <Grid container row spacing={1}>
                  <Grid container item xs={12} sm={8} lg={8} spacing={1}>
                     {/* orderNumber p-1*/}
                     <Grid item xs={12} sm={6} lg={6}>
                      <Card>
                        <CardContent className={classes.cardscontent}>
                          <Grid container spacing={1}>
                            <Grid item xs={6} sm={6} lg={6}>
                              <TextField
                                size="small"
                                id="orderNumber"
                                disabled
                                autoComplete="no"
                                value={MaterialOrderData.orderNumber}
                                onChange={event =>
                                  setMaterialOrderData({
                                    ...MaterialOrderData,
                                    orderNumber: event.target.value
                                  })}
                                fullWidth
                                label={t('lblOrderNumber')}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={5} sm={5} lg={5}>
                              <TextField
                                size="small"
                                id="sapNumber"
                                disabled
                                autoComplete="no"
                                value={MaterialOrderData.sapNumber}
                                onChange={event =>
                                  setMaterialOrderData({
                                    ...MaterialOrderData,
                                    sapNumber: event.target.value
                                  })}
                                fullWidth
                                label={t('lblSapNumber')}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={1} sm={1} lg={1}>
                            {MaterialOrderData.sapNumber !== "" ? 
                              <FormControlLabel
                                control={
                                  <Box p={0.8}>
                                    <ControlCameraIcon
                                      size="small"
                                      color="primary"
                                      style={{ color: '#3399FF' }}
                                      onClick={() => ErpStatusPopup(MaterialOrderData.sapNumber)}
                                    />
                                  </Box>
                                }
                              /> : 
                              <FormControlLabel
                              disabled
                              control={
                                <Box p={0.8}>
                                  <ControlCameraIcon
                                    size="small"
                                    color="primary"
                                    style={{ color: '#93b9c7' }}                               
                                  />
                                </Box>
                              } 
                            />}
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12}>
                              <ThemeProvider theme={materialTheme}>
                                <MuiPickersUtilsProvider
                                  utils={DateFnsUtils}
                                  locale={localeMap[locale]}
                                >
                                  <KeyboardDatePicker
                                    color="primary"
                                    inputVariant="outlined"
                                    id="orderDate"
                                    disabled
                                    size="small"
                                    invalidDateMessage={t('hatali_tarih')}
                                    format="dd.MM.yyyy"
                                    fullWidth
                                    autoComplete="off"
                                    label={t('lblOrderDate')}
                                    variant="outlined"
                                    value={MaterialOrderData.orderDate}
                                    onChange={e => SetDate(e)}
                                    KeyboardButtonProps={{
                                      'aria-label': 'change date'
                                    }}
                                  />
                                </MuiPickersUtilsProvider>
                              </ThemeProvider>
                            </Grid>
                            <Grid item xs={6} sm={12} lg={12}>
                                <TextField
                                  size="small"
                                  disabled
                                  id="ServiceShop"
                                  autoComplete="no"
                                  value={serviceDsc}
                                  fullWidth
                                  label={t('lblServiceShop')}
                                  variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={9} sm={9} lg={9}>
                              <TextField
                                size="small"
                                id="consumer"
                                autoComplete="no"
                                value={serviceAddressData.Dsc ? serviceAddressData.Dsc : serviceAddressData.ShipTo}
                                fullWidth
                                label={t('lblShipTo')}
                                variant="outlined"
                                disabled
                              /> 
                            </Grid>
                            <Grid item xs={3} sm={3} lg={3}>
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: '#1E5128',
                                    color: 'white'
                                  }}
                                  endIcon={<SearchIcon />}
                                  fullWidth
                                  onClick={() => setServiceShopSearchPopUp(true)} 
                                >
                                  {t('search')}
                                </Button>
                              </Grid>
                            <Grid item xs={6} sm={6} lg={6}>
                                <TextField
                                  size="small"
                                  id="consumerName"
                                  disabled
                                  autoComplete="no"
                                  value={serviceAddressData.Name}
                                  fullWidth
                                  label={t('lblConsumerName')}
                                  variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} lg={6}>
                                <TextField
                                  size="small"
                                  id="consumerPhone"
                                  disabled
                                  autoComplete="no"
                                  value={serviceAddressData.Phone}
                                  fullWidth
                                  label={t('lblConsumerPhone')}
                                  variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6}>
                              <TextField
                                size="small"
                                id="status"
                                disabled
                                autoComplete="no"
                                value={MaterialOrderData.status}
                                onChange={event =>
                                  setMaterialOrderData({
                                    ...MaterialOrderData,
                                    status: event.target.value
                                  })}
                                fullWidth
                                label={t('lblStatus')}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6}>
                              <TextField
                                size="small"
                                id="deliveryStatus"
                                disabled
                                autoComplete="no"
                                value={MaterialOrderData.deliveryStatus}
                                fullWidth
                                label={t('lblDeliveryStatus')}
                                variant="outlined"
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid> 
                    {/* jobNumber p-2*/} 
                    <Grid item xs={12} sm={6} lg={6}>
                      <Card>
                        <CardContent className={classes.cardscontent}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} lg={6}>
                            <TextField
                              disabled
                              size="small"
                              id="jobNumber"
                              autoComplete="no"
                              type="number"
                              value={props.WorkOrderId}
                              onKeyDown={blockInvalidChar}
                              onChange={event =>
                                setMaterialOrderData({
                                  ...MaterialOrderData,
                                  jobNumber: event.target.value
                                })}
                              fullWidth
                              label={t('lblWorkOrderId')}
                              variant="outlined"
                              onInput={(e)=>{ 
                                e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,10)
                              }}
                              min={0}
                            />
                            </Grid>
                            <Grid item xs={6} sm={6} lg={6}>
                              <TextField
                                size="small"
                                id="poNumber"
                                autoComplete="no"
                                type="string"
                                value={MaterialOrderData.poNumber}
                                onChange={event =>
                                  setMaterialOrderData({
                                    ...MaterialOrderData,
                                    poNumber: event.target.value.slice(0, 20)
                                  })}
                                fullWidth
                                label={t('PO Number')}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12}>
                            <TextField
                              size="small"
                              id="description"
                              multiline
                              rows={10}
                              autoComplete="no"
                              value={`${props.EngineerOrderDescription || defaultDescription}\n${MaterialOrderData.description}`}
                              onChange={(event) => {
                                const inputValue = event.target.value;
                                const engineerOrderDescriptionLength = (props.EngineerOrderDescription ? props.EngineerOrderDescription + '\n' : defaultDescription + '\n').length;
                                const newDescription = inputValue.substring(engineerOrderDescriptionLength);

                                setMaterialOrderData({
                                  ...MaterialOrderData,
                                  description: newDescription,
                                });
                              }}
                              fullWidth
                              label={t('lblDescription')}
                              variant="outlined"
                            />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                    {/* alert p-4*/}
                    <Grid item xs={12} sm={12} lg={12}>
                        <Alert
                          message={t('priceMessage')}
                          variant={'warning'}
                        />
                    </Grid>
                    {/* material p-5*/}
                    <Grid item xs={12} sm={12} lg={12}>    
                      <Card>
                        <BottomNavigation>
                          <ExcelExport JsonData={exportMaterialData(preOrderMaterials)} ButtonType={1} />
                          <BottomNavigationAction
                            onClick={() => setSelectedMaterialPopup(true)}
                            showLabel
                            label={t('Add Material')}
                            icon={<AddBoxIcon style={{color:'#394867'}} fontSize="large"/>}
                          />
                          <BottomNavigationAction
                            onClick={() => setSelectedProductMaterialPopup(true)}
                            showLabel
                            label={t('Add Material From Product')}
                            icon={<AddBoxIcon style={{color:'#394867'}} fontSize="large"/>}
                          />
                        </BottomNavigation>
                        <Divider />
                        <TableContainer style={{marginTop:'15px'}} component={Paper}>
                            <Table
                              className={classes.table}
                              size="small"
                              aria-label="a dense table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell />
                                  <TableCell />
                                  <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                                  <TableCell align="left">{t('lblMaterial')}</TableCell>
                                  {SessionUser.TenantId === 16 ? 
                                    <TableCell align="left">{t('lblItemNote')}</TableCell>
                                  : <TableCell align="left"/>}
                                  <TableCell align="right">{t('lblQuantity')}</TableCell>
                                  <TableCell align="right">{t('lblPrice')}</TableCell>
                                  <TableCell align="right">{SessionUser.TenantId == 71 || SessionUser.TenantCode == 72 ? t('lblPriceWithGST') : t('lblPriceWithVat')}</TableCell>
                                  <TableCell align="right">{t('lblTotal')}</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {preOrderMaterials.map(row => (
                                  <TableRow key={row.MaterialId}>
                                    <TableCell align="center">
                                      <FormControlLabel
                                        control={
                                          <Box p={0.8}>
                                            <DeleteIcon
                                              size="small"
                                              color="primary"
                                              style={{ color: 'red' }}
                                              onClick={() => deleteFromMaterialTable(row)}
                                            />
                                          </Box>
                                        }
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      <FormControlLabel
                                        control={
                                          <Box p={0.8}>
                                            <LocalGroceryStoreIcon
                                              size="small"
                                              color="primary"
                                              style={{ color: '#3399FF' }}
                                              onClick={() => StokControlPopup(row)}
                                            />
                                          </Box>
                                        }

                                      />
                                    </TableCell>
                                    <TableCell align="left" component="th" scope="row">
                                      {row.MaterialCode}
                                    </TableCell>
                                    <TableCell align="left">{row.MaterialDesc}</TableCell>
                                    {SessionUser.TenantId === 16 ? 
                                      <TableCell align="left">{orderData?.MaterialOrderDetails?.find(x => x.MaterialId === row.MaterialId).ItemNote}</TableCell>
                                    : <TableCell align="left"/>}
                                    <TableCell align="right">
                                      <Input style={{width:'45px', textAlign:'center',backgroundColor: QuantityState.backgroundColor }} type='number' textAlign='center' value={row.Quantity} onChange={(e)=>handleQuantityChange(e,row)} />
                                    </TableCell>                                
                                    <TableCell align="right">
                                      {SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? moneyFormat(
                                        row.Price,
                                        SessionUser.TenantCode,
                                        SessionUser.CurrencyUnit
                                      ) : 0}
                                      {`${SessionUser.CurrencyUnit}`}
                                    </TableCell>
                                    <TableCell align="right">
                                      {SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? moneyFormat(
                                        row.PriceWithWat,
                                        SessionUser.TenantCode,
                                        SessionUser.CurrencyUnit
                                      ) : 0}
                                      {`${SessionUser.CurrencyUnit
                                        }`}
                                    </TableCell>
                                    <TableCell align="right">
                                      {SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? moneyFormat(
                                        row.Total ? row.Total : addToMaterialTable(row,1),
                                        SessionUser.TenantCode,
                                        SessionUser.CurrencyUnit
                                      ) : 0}
                                      {`${SessionUser.CurrencyUnit}`}
                                    </TableCell>
                                  </TableRow>
                                ))}
                                <TableRow>
                                  <TableCell align="center" />
                                  <TableCell align="center" />
                                  <TableCell align="center" />
                                  <TableCell align="center" />
                                  <TableCell align="right">
                                    <b>{t('lblTotal')}</b>
                                  </TableCell>
                                  <TableCell align="center">
                                    <b>
                                      {preOrderMaterials.reduce((n, { Quantity }) => n + parseInt(Quantity), 0)}
                                    </b>
                                  </TableCell>
                                  <TableCell align="right">
                                  <b>
                                    {`${preOrderMaterials.reduce(
                                      (n, { Price }) => n + (SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? Price:0),
                                      0
                                    ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                                  </b>
                                </TableCell>
                                <TableCell align="right">
                                  <b>
                                    {`${preOrderMaterials.reduce(
                                      (n, { PriceWithWat }) => n + (SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? PriceWithWat:0),
                                      0
                                    ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                                  </b>
                                </TableCell>
                                <TableCell align="right">
                                  <b>
                                    {`${preOrderMaterials.reduce(
                                      (n, { Total }) => n + (SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? Total:0),
                                      0
                                    ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                                  </b>
                                </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                        </TableContainer>
                      </Card>
                    </Grid>
                  </Grid>
                 <Grid container item xs={12} sm={4} lg={4} spacing={1}>
                    {/* tab p-3*/}
                    <Grid item xs={12} sm={12} lg={12}>
                        <Card>
                          <CardContent className={classes.cardscontent}>
                            <AppBar position="static">
                              <Tabs value={tabsValue} onChange={handleChangetabs} aria-label="simple tabs example">
                                <Tab label= {t('lblShipTo')} icon={<LocalShippingOutlinedIcon />} {...a11yProps(0)} />
                                <Tab label= {t('lblBillTo')} icon={<DescriptionOutlinedIcon />} {...a11yProps(1)} />
                              </Tabs>
                            </AppBar>
                            <TabPanel value={tabsValue} index={0}>
                              <ConsumerAddress
                                disabled 
                                consumerAddressData={serviceAddressData}
                                serviceAddressData={serviceAddressData} //name,email,phone 
                                setStreetData={setStreetData}
                                setApartmentData={setApartmentData}
                                setAddressData={setAddressData}
                                setStateData={setStateData}
                                setAddressItemData={setAddressItemData}
                                setCityData={setCityData}
                                setCountryData={setCountryData}
                                setDistrictData={setDistrictData}
                                setDoorNrData={setDoorNrData}
                                setNeighborhoodData={setNeighborhoodData}
                                setTaxNumberData={setTaxNumberData}
                                setPostCodeData={setPostCodeData}
                                setRegionData={setRegionData}
                                setEmailData={setEmailData}
                                setPhoneData={setPhoneData}
                                setNameData={setNameData}
                                setAddressTypeIdData={setAddressTypeIdData}
                              /> 
                            </TabPanel>
                            <TabPanel value={tabsValue} index={1}>
                              <ServiceShopBillTo 
                                  serviceAddressData={serviceShopDetails[0]} 
                                /> 
                            </TabPanel>
                          </CardContent>
                        </Card>
                    </Grid>
                  </Grid>  
                </Grid>
              </CardContent>
            </Card>
            <Dialog
              open={ServiceShopSearchPopUp}
              onClose={() => setServiceShopSearchPopUp(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth
              maxWidth="lg"
            >
            <DialogTitle id="alert-dialog-title">
              {t('lblServiceShopSearch')}
              <Divider />
            </DialogTitle>
            <DialogContent>
              <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <ServiceShopSearchPartner 
                        handleClickService={handleClickService}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                style={{backgroundColor:'#B31312',color:'white'}}
                size="small"
                component="span"
                onClick={() => setServiceShopSearchPopUp(false)}
              >
                 {t('lblClose')}
              </Button>
            </DialogActions>
            </Dialog>
            <EditMaterial
            open={openEdit}
            value={1}
            min={1}
            max={999}
            onClose={handleCloseEdit}
            materialId = {materialId}
            materialCode = {materialCode}
            materialDesc = {materialDesc}
            sparePartMessage={sparePartMessage}
            setQuantityNum = {setQuantityNum}
          />
            {/* Add Material From Product BOM */}
            <Dialog
              open={SelectedProductMaterialPopup}
              fullWidth
              maxWidth="lg"
              onClose={() => setSelectedProductMaterialPopup(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description" >
            <Grid container >
                <Grid xs={1} sm={1} lg={1}></Grid>
                <Grid item xs={10} sm={10} lg={10}>
                <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                {t('Add Material From Product BOM')}
              </DialogTitle>
                </Grid>
                <Grid xs={1} sm={1} lg={1}>
                  <DialogActions>
                    <IconButton
                      color="primary"
                      onClick={() => setSelectedProductMaterialPopup(false)}
                      aria-label="upload picture"
                      component="span">
                      <CloseIcon />
                    </IconButton>
                  </DialogActions>
                </Grid>
            </Grid>
              <Container maxWidth="xl" spacing={1}>
                <Divider />
                <Card>
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} lg={12}>
                        <UrunSearch
                          setModel={setModel}
                          value={
                            {
                              KUL_MODEL_KODU: UrunData.ModelCode,
                              ACIKLAMA: UrunData.Model
                            } || ''
                          }
                          searchParam={search}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                          <SerialNumberParse 
                            SKU={UrunData.ModelCode}
                            MODEL={UrunData.Model}
                            BRANDCODE={UrunData.BrandCode}
                            PRODUCTID={UrunData.ProductId}
                            GetHistoricalBom={GetHistoricalBom}
                          />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <ProductMaterialSearch
                          setProductMaterial={setProductMaterial}
                          materialIsVisible={(UrunData.Model && UrunData.ModelCode && UrunData.ProductId >= 1000000) ? true : false}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item xs={4} sm={4} lg={4}>
                        <SearchBar
                          inputSizeSmall
                          value={searched}
                          onChange={searchVal => requestSearch(searchVal)}
                          onCancelSearch={() => cancelSearch()}
                          style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TableContainer component={Paper}>
                          <Table
                            stickyHeader
                            className={classes.table}
                            size="small"
                            aria-label="sticky table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell align="left">
                                  {t('lblMaterialCode')}
                                </TableCell>
                                <TableCell align="left">
                                  {t('lblDescription')}
                                </TableCell>
                                <TableCell align="left">
                                  {t('lblRef')}
                                </TableCell>
                                <TableCell align="right">{t('lblPrice')}</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(rowsPerPage > 0
                                ? MaterialListData.slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                                : MaterialListData
                              ).map(row => (
                                <TableRow key={row.MaterialId} style={preOrderMaterials.includes(row) ? {backgroundColor:'#DEF5E5'} : {}}>
                                  <TableCell
                                    align="center"
                                    className={classes.tableCellMaterial}
                                  >
                                    <FormControlLabel
                                      control={
                                        <ImageSearchIcon
                                          onClick={() =>
                                            malzemeGosterMaterial(row.MaterialCode)
                                          }
                                          color="primary"
                                        >
                                        </ImageSearchIcon>
                                      }
                                    />
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    <TrackChangesIcon
                                      onClick={() => { GetSiriusMaterialsBySearchKey(row.ActiveEquivalent,row.MaterialCode) }}
                                      color="primary"
                                    >
                                    </TrackChangesIcon>
                                  </TableCell>
                                  <TableCell align="center">
                                    <FormControlLabel
                                      control={
                                        <AddBoxIcon
                                          color="primary"
                                          onClick={() => addToMaterialTable(row,0)}
                                        />
                                      }
                                    />
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.MaterialCode}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.MaterialDesc}
                                    {row.ActiveEquivalent ? (
                                      <Chip color="secondary" size="small" label="M" />
                                    ) : ''}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.Ref}
                                  </TableCell>
                                  <TableCell align="right">
                                    {`${SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ? row.PriceWithWat ? row.PriceWithWat.toFixed(2): 0 : 0} ${SessionUser.CurrencyUnit
                                      }`}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                          <TablePagination
                            rowsPerPageOptions={[5, 10]}
                            component="div"
                            count={MaterialListData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                          />
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Container>
              <DialogActions/>
            </Dialog>
            {/* Material Add */}
            <Dialog
              open={SelectedMaterialPopup}
              fullWidth
              maxWidth="lg"
              onClose={() => setSelectedMaterialPopup(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <Grid container >
                <Grid xs={1} sm={1} lg={1}></Grid>
                <Grid item xs={10} sm={10} lg={10}>
                  <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                      {t('lblMaterialChoose')}
                  </DialogTitle>
                </Grid>
                <Grid xs={1} sm={1} lg={1}>
                  <DialogActions>
                    <IconButton
                      color="primary"
                      onClick={() => setSelectedMaterialPopup(false)}
                      aria-label="upload picture"
                      component="span">
                      <CloseIcon />
                    </IconButton>
                  </DialogActions>
                </Grid>
              </Grid>
              <Container maxWidth="xl" spacing={1}>
                <Divider />
                <Card>
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} lg={12}>
                        <OutlinedInput
                          id="outlined-adornment"
                          fullWidth
                          placeholder={t('Please Enter Material Code Or Name Or SKU (For BOM) Then Click The Button')}
                          value={inputText}
                          onChange={handleChange}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton type="button" sx={{ p: '10px' }} aria-label="search"
                              onClick={setSearchMaterial}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item xs={4} sm={4} lg={4}>
                        <SearchBar
                          value={searched}
                          onChange={searchVal => requestSearch2(searchVal)}
                          onCancelSearch={() => cancelSearch()}
                          style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                        />
                      </Grid>
                      <Grid item xs={4} sm={4} lg={4}>
                        <input
                          id="FileInput"
                          type='file'
                          onChange={importExcel}
                          hidden
                          accept=".xlsx, .xls, .xml"
                        >
                        </input>
                        <label htmlFor="FileInput">
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            fullWidth
                            component="span"
                          >
                            {t('lblChooseFile')}
                          </Button>
                        </label>
                      </Grid>
                      <Grid item xs={4} sm={4} lg={4}>
                        <ExcelExport JsonData={exportExcelExample} ButtonType={5} ButtonText={'EXCEL EXAMPLE'}/>
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TableContainer component={Paper}>
                          <Table
                            stickyHeader
                            className={classes.table}
                            size="small"
                            aria-label="sticky table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell align="left">
                                  {t('lblMaterialCode')}
                                </TableCell>
                                <TableCell align="left">
                                  {t('lblDescription')}
                                </TableCell>
                                <TableCell align="right">{t('lblPrice')}</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(rowsPerPage > 0
                                ? MaterialListData2.slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                                : MaterialListData2
                              ).map(row => (
                                <TableRow key={row.MaterialId} style={preOrderMaterials.includes(row) ? {backgroundColor:'#DEF5E5'} : {}}>
                                  <TableCell
                                    align="center"
                                    className={classes.tableCellMaterial}
                                  >
                                    <FormControlLabel
                                      control={
                                        <ImageSearchIcon
                                          onClick={() =>
                                            malzemeGosterMaterial(row.MaterialCode)
                                          }
                                          color="primary"
                                        >
                                        </ImageSearchIcon>
                                      }
                                    />
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>
                                    <TrackChangesIcon
                                      onClick={() => { GetSiriusMaterialsBySearchKey(row.ActiveEquivalent,row.MaterialCode) }}
                                      color="primary"
                                    >
                                    </TrackChangesIcon>
                                    </TableCell>
                                  <TableCell align="center">
                                    <FormControlLabel
                                      control={
                                        <AddBoxIcon
                                          color="primary"
                                          onClick={() => addToMaterialTable(row,0)}
                                        />
                                      }
                                    />
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.MaterialCode}
                                  </TableCell>
                                  <TableCell align="left">
                                      {row.MaterialDesc}
                                      {row.ActiveEquivalent ? (
                                        <Chip color="secondary" size="small" label="M" />
                                      ) : ''}
                                  </TableCell>
                                  <TableCell align="right">
                                    {`${SessionUser.ServiceShopPriceVisible && !SessionUser.EmployeePriceVisible ?(row.PriceWithWat.toFixed(2)):0} ${SessionUser.CurrencyUnit
                                      }`}  
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                          <TablePagination
                            rowsPerPageOptions={[5, 10]}
                            component="div"
                            count={MaterialListData2.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                          />
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Container>
              <DialogActions/>
            </Dialog>
            {/* EQUIVALENT MATERIALS */}
            <Dialog
            fullWidth
            open={muadilOpen}
            onClose={() => setMuadilOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {muadilTitle} {t('lblMalzemeninBulteni')}
            </DialogTitle>
            <DialogContent>
              <TableContainer>
                <Table size="small" aria-label="material table">
                  <TableBody className={classes.table}>
                    {muadilParam.length === 0
                      ? '...'
                      : muadilParam.split(',').map((m, index) => {
                        return getMaterialRow(equivalentData, index);
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setMuadilOpen(false)}
                className={classes.button}
                endIcon={<CloseIcon>Close</CloseIcon>}
              >
                {t('lblOkey')}
              </Button>
            </DialogActions>
          </Dialog>
            {/* Missing Materials */}
            <Dialog
              open={MissingMaterialsPopUp}
              fullWidth
              maxWidth="lg"
              onClose={() => missingMaterialsPopUp(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <Grid container >
                <Grid xs={1} sm={1} lg={1}></Grid>
                <Grid item xs={10} sm={10} lg={10}>
                  <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                      {t('Missing Materials')}
                  </DialogTitle>
                </Grid>
                <Grid xs={1} sm={1} lg={1}>
                  <DialogActions>
                    <IconButton
                      color="primary"
                      onClick={() => missingMaterialsPopUp(false)}
                      aria-label="upload picture"
                      component="span">
                      <CloseIcon />
                    </IconButton>
                  </DialogActions>
                </Grid>
              </Grid>
              <Container maxWidth="xl" spacing={1}>
              <label style={{ color: 'red' }}>The following material codes were not found or defined in your region</label>
                <Divider />
                <Paper style={{maxHeight: 300, overflow: 'auto'}}>
                <List>
                {MissingMaterials.map((item) => 
                  <ListItem>
                    <ListItemText >{item.MaterialCode}</ListItemText >
                  </ListItem>
                )}
                  </List>
                </Paper>
              </Container>
              <DialogActions/>
            </Dialog>
            <Dialog
              open={ImagePopup}
              fullWidth
              maxWidth="sm"
              onClose={() => setImagePopup(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
            </Dialog>

            <Dialog
          open={stokOpen}
          onClose={() => setStokOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            {t('lblMaterialStockSituation')}
            <Divider />
          </DialogTitle>
          <DialogContent>
          <List component="div" dense>
          {loading2 ? (
            <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
          ) : (
            <>
              {/* stokDataOwnEngineer */}
               {(serviceShopTypeId === 1 || (SessionUser.TenantId === 46 && serviceShopTypeId === 2)) ? (
                              <>
                                {stokDataOwnEngineer.length > 0 ? (
                                  <>
                                    <Typography>{t('VanStock')}</Typography>
                                    {stokDataOwnEngineer.map((s, index) => (
                                      <React.Fragment key={index}>
                                        <ListItem fullWidth alignItems="flex-start">
                                          <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                                          <ListItemText
                                            primary={
                                              <Typography variant="body1" className={classes.nestedRight}>
                                                <b>{s.MaterialCode}</b>
                                              </Typography>
                                            }
                                            secondary={
                                              <>
                                                <Typography
                                                  component="span"
                                                  variant="h6"
                                                  className={classes.inline}
                                                  color="textPrimary"
                                                >
                                                  {t('OwnEngineer')} : {s.StorageLocation}
                                                  <br />
                                                  {t('lblAdet')} : {s.Quantity}
                                                  <br />
                                                  {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : '-'}
                                                  <br />
                                                  {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 ? (
                                                    <div>
                                                      {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity === 0 ? '-' : moment(s.ETA).format('DD/MM/YYYY')}
                                                    </div>
                                                  ) : null}
                                                </Typography>
                                              </>
                                            }
                                          />
                                        </ListItem>
                                        <Divider variant="inset" component="li" />
                                      </React.Fragment>
                                    ))}
                                  </>
                                ) : (
                                  <Typography>{stockMsg}</Typography>
                                )}
                              </>
                            ) : null}
              <Divider variant="inset" component="li" />
              {/* stokData */}
              {stokData.length > 0 && IsAllOwnEngineer == false ? <Typography>Stock Data</Typography> : ''}
              {stokData.length > 0 && IsAllOwnEngineer == false ? stokData.map((s, index) => (
                <React.Fragment key={index}>
                  <ListItem fullWidth alignItems="flex-start">
                    <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body1"
                          className={classes.nestedRight}
                        >
                          <b>{s.MaterialCode}</b>
                        </Typography>
                      }
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="h6"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {t('StorageDesc')} : {s.StorageLocation}
                            <br />
                            {t('lblAdet')} : {s.Quantity}
                            <br />
                            {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : "-"}
                            <br />
                            {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 && (
                              <div>
                                {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity == 0 ? "-" : moment(s.ETA).format('DD/MM/YYYY')}
                              </div>
                            )}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </React.Fragment>
              )) : ''}
            </>
          )}
        </List>
          </DialogContent>
          <DialogActions>
          {(serviceShopTypeId === 1 || (SessionUser.TenantId === 46 && serviceShopTypeId === 2)) ? (
                      <div>
                        {backButtonVisible ? ( 
                          <Button 
                            variant="contained" 
                            color="primary"
                            onClick={handleBackButtonClick}
                          >
                            {t('lblBack')}
                          </Button>
                        ) : (
                          <Button 
                            variant="contained"
                            color="primary"
                            onClick={() => StockSearch(false)} 
                          >
                            {t('lblFieldStock')}
                          </Button>
                        )}
                      </div>
                    ) : null}
            <Button 
              variant="contained"
              color="primary"
              onClick={() => {setStokOpen(false);
              setBackButtonVisible(false)}} 
            >
              {t('lblOk')}
            </Button>
          </DialogActions>
            </Dialog>
                <Dialog
                  open={ErpStatusOpen}
                  onClose={() => setErpStatusOpen(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  fullWidth
                  maxWidth='lg'
                >
                  <DialogTitle id="alert-dialog-title">
            <Typography  className={classes.typoHead}  variant="h3">{t('lblSparePartorderDetails')}</Typography>
              <Divider />
            </DialogTitle>
            <DialogContent>
              <List>
                <Grid>
                {loading ? (
                  <CircularProgress
                    status="loading"
                    style={{ marginLeft: '50%' }}
                  />
                  
                ) : 
                  (
                    ErpStatusData?.out?.map(s => {
                      return (
                        <Grid>
                          <ListItem
                            fullWidth
                            alignItems="flex-start"
                            key={s.ORDER_NO}
                          >
                            <ListItemText
                              secondary={
                                <React.Fragment>
                                  <ListItem fullWidth alignItems="flex-start">
                                    <ListItemText
                                      secondary={
                                        <React.Fragment>
                                          <TableContainer component={Paper}>
                                            <Table className={classes.table} aria-label="customized table">
                                              <TableHead>
                                                <TableRow>
                                                  <StyledTableCell align="center">{t('lblOrderNo')}</StyledTableCell>
                                                  <StyledTableCell align="center">{t('lblOrderItem')}</StyledTableCell>
                                                  <StyledTableCell align="center">{t('lblOrderStatus')}</StyledTableCell>
                                                  <StyledTableCell align="center">{t('lblOrderDesc')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblOrderDate')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblDeliveryNo')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblDeliveryStatus')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblDeliveryDate')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblInvoiceNo')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblInvoiceDate')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblGoodIssueDate')}</StyledTableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                <StyledTableRow>
                                                  <StyledTableCell align='left'>{s.ORDER_NO}</StyledTableCell>
                                                  <StyledTableCell align="center">{s.ORDER_ITEM}</StyledTableCell>
                                                  <StyledTableCell align="right">{s.ORDER_STATUS}</StyledTableCell>
                                                  <StyledTableCell align="center">{s.ORDER_DESC}</StyledTableCell>
                                                  <TableCell align="left">{s.ORDER_DATE === "0000-00-00" ? '' : SessionUser.TenantId == 79 ? moment(s.ORDER_DATE).format('MM/DD/YYYY HH:mm') : moment(s.ORDER_DATE).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                  <StyledTableCell align="left">{s.DELIVERY_NO}</StyledTableCell>
                                                  <StyledTableCell align="left">{s.DELIVERY_STATUS}</StyledTableCell>
                                                  <TableCell align="left">{s.DELIVERY_DATE === "0000-00-00" ? '' : SessionUser.TenantId == 79 ? moment(s.DELIVERY_DATE).format('MM/DD/YYYY HH:mm') : moment(s.DELIVERY_DATE).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                  <StyledTableCell align="left">{s.INVOICE_NO}</StyledTableCell>
                                                  <TableCell align="left">{s.INVOICE_DATE === "0000-00-00" ? '' : SessionUser.TenantId == 79 ? moment(s.INVOICE_DATE).format('MM/DD/YYYY HH:mm') : moment(s.INVOICE_DATE).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                  <TableCell align="left">{s.GOOD_ISSUE_DATE === "0000-00-00" ? '' : SessionUser.TenantId == 79 ? moment(s.GOOD_ISSUE_DATE).format('MM/DD/YYYY HH:mm') : moment(s.GOOD_ISSUE_DATE).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                </StyledTableRow>
                                              </TableBody>
                                            </Table>
                                          </TableContainer>
                                        </React.Fragment>
                                      }
                                    />
                                  </ListItem>
                                  <Divider variant="inset" component="li" />
                                  <Divider variant="inset" component="li" />
                                </React.Fragment>
                              }
                            />
                          </ListItem>
                          <Divider variant="inset" component="li" />
                          <Divider variant="inset" component="li" />
                        </Grid>
                        
                      );
                    })
                  )}
                </Grid>
              </List>
              
              {/* <Grid container item xs={12} sm={12} lg={12} row spacing={1} >
                {loading ? (
                  <CircularProgress
                    status="loading"
                    style={{ marginLeft: '50%' }}
                  />
                ) : (
                  ErpStatusData?.orderPartner?.map(s => {
                    return (
                      <Grid item xs={12} sm={3} lg={3}>
                            <Card>
                              <Grid container column justify='center'>
                                <ListItemAvatar>{getSpareUserColor(s)}</ListItemAvatar>
                              </Grid>
                              <CardContent>
                                <Typography style={{fontWeight: 'bold'}} variant="body1" component="p">
                                  {t('lblOrderNo')}: 
                                </Typography>{s.ORDER_NO}
                                <br/>
                                <Typography style={{fontWeight: 'bold'}} variant="body1" component="p">
                                  {t('lblPartnerCode')}: 
                                </Typography>{s.PARTNERCODE}
                                <br/>
                                <Typography style={{fontWeight: 'bold'}} variant="body1" component="p">
                                  {t('lblPartnerDesc')}: 
                                </Typography>{s.PARTNERDESC}
                                <br/>
                                <Typography style={{fontWeight: 'bold'}} variant="body1" component="p">
                                  {t('lblPartnerType')}: 
                                </Typography>{s.PARTNERTYPE}
                              </CardContent>
                            </Card>
                    </Grid>
                    );
                  })
                )}
              </Grid> */}
            </DialogContent>
                </Dialog>
        </Container>
      </Page >
    );
};


export default TriageMaterialOrder;